
























































































































































































































































































import { mixins } from "vue-class-component";
import { Component, Vue } from "vue-property-decorator";
import { Row, Col, NavBar, Cell, CellGroup, Button } from "vant";
import DemoBlock from "@/components/DemoBlock.vue";
import DemoSection from "@/components/DemoSection.vue";
import WeMixin from "@/components/weMixin";

@Component({
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [NavBar.name]: NavBar,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    DemoBlock,
    DemoSection,
  },
})
export default class DemoDocPage extends mixins(WeMixin) {
  private imgurl: string = require("@/assets/logo.png");

  private goto(url: string) {
    // debugger;
    window.open(url);
  }
}
